var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"","enter-class":"","enter-to-class":"","leave-active-class":"transition ease-in duration-100","leave-class":"opacity-100","leave-to-class":"opacity-0"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }